// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__r2iEh","active":"Chip_active__DOLeZ"};